import Landing from 'features/landing/Landing';

const LandingPage = () => <Landing />;

export default LandingPage;
